import {getLanguage} from '../i18n/i18n';

export type NumericFormatter = (value: number) => string;

export type ValueFormat = NumericFormatter | undefined;

export const formatValue = (data: number | string, numericFormatter?: NumericFormatter): string => {
    if (numericFormatter) {
        const parsedNumber = typeof data === 'string' ? parseFloat(data) : data;
        const finiteNumber = parsedNumber === undefined || isNaN(parsedNumber) || !isFinite(parsedNumber) ? 0 : parsedNumber;
        return numericFormatter(finiteNumber);
    }
    return typeof data === 'number' ? data.toString() : data;
};

const makeNumericFormatter = (options: Intl.NumberFormatOptions): NumericFormatter => {
    return Intl.NumberFormat(getLanguage(), options).format;
};

export const textFormat = () => {
    return undefined;
};

type CurrencyType<T> = T & {currency?: string};

export const moneyFormat = <T>(provider?: CurrencyType<T>, fractionDigits = 2) => {
    if (!provider || !provider.currency) {
        return numberFormat(2);
    }
    return makeNumericFormatter({
        style: 'currency',
        currency: provider.currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};

export const currencySymbol = <T>(provider: CurrencyType<T>): string => {
    return formatValue(0, moneyFormat(provider, 0)).replace('0', '');
};

export const numberFormat = (minFractionDigits = 0, maxFractionDigits = minFractionDigits) => {
    return makeNumericFormatter({
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: maxFractionDigits,
    });
};

export const percentFormat = (minFractionDigits = 1, maxFractionDigits = minFractionDigits) => {
    return makeNumericFormatter({
        style: 'percent',
        minimumFractionDigits: minFractionDigits,
        maximumFractionDigits: maxFractionDigits,
    });
};



// WEBPACK FOOTER //
// ./src/utility/FormatValueUtils.ts